(function() {
  function addTrust() {
    var btns = document.querySelectorAll('.product-form__submit, button[name="add"]');
    btns.forEach(function(btn) {
      if (btn.parentNode.querySelector('.wakse-trust')) return;
      var trust = document.createElement('div');
      trust.className = 'wakse-trust';
      trust.innerHTML = '<span>Free shipping over $25</span> · <span>Secure checkout</span>';
      btn.parentNode.insertBefore(trust, btn.nextSibling);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addTrust);
  } else {
    addTrust();
  }
  setTimeout(addTrust, 1200);
})();
